import { Component, OnInit } from '@angular/core';
import { MonthlyactiveuserService } from './monthlyactiveuser.service';
import { MatTableDataSource } from "@angular/material/table";
import * as moment from 'moment';
import { ApplicationService } from '../application/application.service';
import { merge, Observable } from 'rxjs';
@Component({
  selector: 'app-monthly-active-user',
  templateUrl: './monthly-active-user.component.html',
  styleUrls: ['./monthly-active-user.component.scss']
})
export class MonthlyActiveUserComponent implements OnInit {
  c:any;
  arr1:any=[];
  applicationName:any=[];
  isHidden:any=false;
  isHidden1:any=false;
  isHidden9:any=false;
  isHidden2:any=false;
  isHidden3:any=false;
  isHidden4:any=false;
  isHidden5:any=false;
  isHidden6:any=false;
  isHidden7:any=false;
  isHidden8:any=false;
  isHidden10:any=false;
  isHidden11:any=false;
  isHidden12:any=false;
  isHidden13:any=false;
  columns: string[];
  formattedMonth1;
  formattedMonth2;
  formattedMonth3:any;
  formattedMonth4:any;
  formattedMonth5:any;
  formattedMonth6:any;
  formattedMonth7:any;
  formattedMonth8:any;
  formattedMonth9:any;
  formattedMonth10:any;
  formattedMonth11:any;
  formattedMonth12:any;
  formattedMonth13:any;
  formattedMonth14:any;
  search:any;
  userId:any;
  month20:any
  year20:any;
  monthName:any;
  month21:any
  year21:any;
  monthName1:any;
  month22:any
  year22:any;
  monthName2:any;
  month23:any
  year23:any;
  monthName3:any;
  month24:any
  year24:any;
  monthName4:any;
  month25:any
  year25:any;
  monthName5:any;
  month26:any
  year26:any;
  monthName6:any;
  month27:any
  year27:any;
  monthName7:any;
  month28:any
  year28:any;
  monthName8:any;
  month29:any
  year29:any;
  monthName9:any;
  month30:any
  year30:any;
  monthName10:any;
  month31:any
  year31:any;
  monthName11:any;
  month32:any
  year32:any;
  monthName12:any;
  month33:any
  year33:any;
  monthName13:any;
  month34:any
  year34:any;
  monthName14:any;


  arr:any=[];
  applicationList:any=[];
  dataSource: any=[];
  pageLoader:boolean = true;
  page:number=1;
  paginationDisabled: boolean=false;
  paginationCount:number=0;
  todaysDate: any = moment();
  constructor(private monthlyactiveuserService : MonthlyactiveuserService, private applicationService: ApplicationService,) { }
 
  displayedColumns: string[] = [
    "reseller",
    "application",
    "activeusers",
    "previousmonth1",
    "previousmonth2",
    "previousmonth3",
    "previousmonth4",
    "previousmonth5",
    "previousmonth6",
    "previousmonth7",
    "previousmonth9", 
    "previousmonth10",
    "previousmonth11",
    "previousmonth12",
    "previousmonth13"
  ];
  ngOnInit(): void {
    this.userId = JSON.parse(localStorage.getItem('user')).id;
   
    this.pageLoader =true;  
    this.getApplication();
   
   
  }
  
  getApplication(){
    let args = {
      "developerId" : this.userId 
    }
    this.monthlyactiveuserService.getResellerList(args).subscribe((data) => {
      console.log(data)
      if(data){
        this.pageLoader=false;
        this.applicationList = data;
       
        this.arr =  this.applicationList;

        this.applicationList.forEach(element => {
         element.company = data ? element.company : '';
         element.applicationName = data ? element.applicationName : '';
         element.activeUsers = data ? element.activeUsers : '';

         var month1 = moment(this.todaysDate).subtract(0,'month').startOf('month').format('YYYY-MM-DD');
         var check = moment(month1, 'YYYY/MM/DD');
         this.month20 = check.format('M');
         this.formattedMonth1 = moment(this.month20, 'MM').format('MMMM');
         this.year20  = check.format('YYYY');
      
       let argsmonth20 = {
        "developerId" : element.developerId,
        "applicationId" : element.applicationId,
        "month" : this.formattedMonth1,
        "year" : this.year20
       }
       this.isHidden = true;
       this.applicationService.getMonthlyActiveUsers(argsmonth20).subscribe((data) => {
        if(data){
         
          element.count = data.info.count;
          if(data.info.count){
            this.isHidden = false;
          }
    }
    else{
     
    }
   }
   ,err =>{
    
   });


         var month2 = moment(this.todaysDate).subtract(1,'month').startOf('month').format('YYYY-MM-DD');
         var check1 = moment(month2, 'YYYY/MM/DD');
         this.month21 = check1.format('M');
         this.formattedMonth2 = moment(this.month21, 'MM').format('MMMM');
         this.year21  = check1.format('YYYY');
      
       let argsmonth21 = {
        "developerId" : element.developerId,
        "applicationId" : element.applicationId,
        "month" : this.formattedMonth2,
        "year" : this.year21
       }
       this.isHidden1 = true;
       this.applicationService.getMonthlyActiveUsers(argsmonth21).subscribe((data) => {
        if(data){
          element.count1 = data.info.count;
         
          if(data.info.count){
            this.isHidden1 = false;
          } 
       
    }
    else{
     
    }
   }
   ,err =>{
    
   });



   var month3 = moment(this.todaysDate).subtract(2,'month').startOf('month').format('YYYY-MM-DD');
   var check3 = moment(month3, 'YYYY/MM/DD');
   this.month22 = check3.format('M');
   this.year22  = check3.format('YYYY');
   this.formattedMonth3 = moment(this.month22, 'MM').format('MMMM');
   
   let argsmonth22 = {
    "developerId" : element.developerId,
    "applicationId" : element.applicationId,
    "month" : this.formattedMonth3,
    "year" : this.year22
   }
   this.isHidden2 = true;
   this.applicationService.getMonthlyActiveUsers(argsmonth22).subscribe((data) => {
    if(data){
      element.count2 = data.info.count;
      if(data.info.count){
        this.isHidden2 = false;
      }
}
else{
 
}
}
,err =>{

});

var month4 = moment(this.todaysDate).subtract(3,'month').startOf('month').format('YYYY-MM-DD');
var check4 = moment(month4, 'YYYY/MM/DD');
this.month23 = check4.format('M');
this.year23  = check4.format('YYYY');
this.formattedMonth4 = moment(this.month23, 'MM').format('MMMM');

let argsmonth23 = {
 "developerId" : element.developerId,
 "applicationId" : element.applicationId,
 "month" : this.formattedMonth4,
 "year" : this.year23
}
this.isHidden3 = true;
this.applicationService.getMonthlyActiveUsers(argsmonth23).subscribe((data) => {
 if(data){
   element.count3 = data.info.count;
   if(data.info.count){
    this.isHidden3 = false;
  }
}
else{

}
}
,err =>{

});



var month5 = moment(this.todaysDate).subtract(4,'month').startOf('month').format('YYYY-MM-DD');
var check5 = moment(month5, 'YYYY/MM/DD');
this.month24 = check5.format('M');
this.year24  = check5.format('YYYY');
this.formattedMonth5 = moment(this.month24, 'MM').format('MMMM');

let argsmonth24 = {
 "developerId" : element.developerId,
 "applicationId" : element.applicationId,
 "month" : this.formattedMonth5,
 "year" : this.year24
}
this.isHidden4 = true;
this.applicationService.getMonthlyActiveUsers(argsmonth24).subscribe((data) => {
 if(data){
   element.count4 = data.info.count;
   if(data.info.count){
    this.isHidden4 = false;
  }
}
else{

}
}
,err =>{

});


var month6 = moment(this.todaysDate).subtract(5,'month').startOf('month').format('YYYY-MM-DD');
var check6 = moment(month6, 'YYYY/MM/DD');
this.month26 = check6.format('M');
this.year26  = check6.format('YYYY');
this.formattedMonth6 = moment(this.month26, 'MM').format('MMMM');

let argsmonth26 = {
 "developerId" : element.developerId,
 "applicationId" : element.applicationId,
 "month" : this.formattedMonth6,
 "year" : this.year26
}

this.isHidden5 = true;
this.applicationService.getMonthlyActiveUsers(argsmonth26).subscribe((data) => {
 if(data){
   element.count5 = data.info.count;
   if(data.info.count){
    this.isHidden5 = false;
  }
}
else{

}
}
,err =>{

});


var month7 = moment(this.todaysDate).subtract(6,'month').startOf('month').format('YYYY-MM-DD');
var check7 = moment(month7, 'YYYY/MM/DD');
this.month27 = check7.format('M');
this.year27  = check7.format('YYYY');
this.formattedMonth7 = moment(this.month27, 'MM').format('MMMM');

let argsmonth27 = {
 "developerId" : element.developerId,
 "applicationId" : element.applicationId,
 "month" : this.formattedMonth7,
 "year" : this.year27
}
this.isHidden6 = true;
this.applicationService.getMonthlyActiveUsers(argsmonth27).subscribe((data) => {
 if(data){
   element.count6 = data.info.count;
   if(data.info.count){
    this.isHidden6 = false;
  }
}
else{

}
}
,err =>{

});

var month8 = moment(this.todaysDate).subtract(7,'month').startOf('month').format('YYYY-MM-DD');
var check8 = moment(month8, 'YYYY/MM/DD');
this.month28 = check8.format('M');
this.year28  = check8.format('YYYY');
this.formattedMonth8 = moment(this.month28, 'MM').format('MMMM');

let argsmonth28 = {
 "developerId" : element.developerId,
 "applicationId" : element.applicationId,
 "month" : this.formattedMonth8,
 "year" : this.year28
}

this.isHidden7 = true;
this.applicationService.getMonthlyActiveUsers(argsmonth28).subscribe((data) => {
 if(data){
   element.count7 = data.info.count;
   if(data.info.count){
    this.isHidden7 = false;
  }
}
else{

}
}
,err =>{

});


var month9 = moment(this.todaysDate).subtract(8,'month').startOf('month').format('YYYY-MM-DD');
var check9 = moment(month9, 'YYYY/MM/DD');
this.month30 = check9.format('M');
this.year30  = check9.format('YYYY');
this.formattedMonth9 = moment(this.month30, 'MM').format('MMMM');

let argsmonth30 = {
 "developerId" : element.developerId,
 "applicationId" : element.applicationId,
 "month" : this.formattedMonth9,
 "year" : this.year30
}

this.isHidden9 = true;
this.applicationService.getMonthlyActiveUsers(argsmonth30).subscribe((data) => {
 if(data){
   element.count9 = data.info.count;
   if(data.info.count){
    this.isHidden9 = false;
  }
}
else{

}
}
,err =>{

});


var month10 = moment(this.todaysDate).subtract(9,'month').startOf('month').format('YYYY-MM-DD');
var check10 = moment(month10, 'YYYY/MM/DD');
this.month31 = check10.format('M');
this.year31  = check10.format('YYYY');
this.formattedMonth10 = moment(this.month31, 'MM').format('MMMM');

let argsmonth31 = {
 "developerId" : element.developerId,
 "applicationId" : element.applicationId,
 "month" : this.formattedMonth10,
 "year" : this.year31
}

this.isHidden10 = true;
this.applicationService.getMonthlyActiveUsers(argsmonth31).subscribe((data) => {
 if(data){
   element.count10 = data.info.count;
   if(data.info.count){
    this.isHidden10 = false;
  }
}
else{

}
}
,err =>{

});









var month11 = moment(this.todaysDate).subtract(10,'month').startOf('month').format('YYYY-MM-DD');
var check11 = moment(month11, 'YYYY/MM/DD');
this.month32 = check11.format('M');
this.year32  = check11.format('YYYY');
this.formattedMonth11 = moment(this.month32, 'MM').format('MMMM');

let argsmonth32 = {
 "developerId" : element.developerId,
 "applicationId" : element.applicationId,
 "month" : this.formattedMonth11,
 "year" : this.year32
}

this.isHidden11 = true;
this.applicationService.getMonthlyActiveUsers(argsmonth32).subscribe((data) => {
 if(data){
   element.count11 = data.info.count;
   if(data.info.count){
    this.isHidden11 = false;
  }
}
else{

}
}
,err =>{

});



var month12 = moment(this.todaysDate).subtract(11,'month').startOf('month').format('YYYY-MM-DD');
var check12 = moment(month12, 'YYYY/MM/DD');
this.month33 = check12.format('M');
this.year33  = check12.format('YYYY');
this.formattedMonth14 = moment(this.month33, 'MM').format('MMMM');

let argsmonth33 = {
 "developerId" : element.developerId,
 "applicationId" : element.applicationId,
 "month" : this.formattedMonth14,
 "year" : this.year33
}

this.isHidden12 = true;
this.applicationService.getMonthlyActiveUsers(argsmonth33).subscribe((data) => {
 if(data){
   element.count12 = data.info.count;
   if(data.info.count){
    this.isHidden12 = false;
  }
}
else{

}
}
,err =>{

});



var month13 = moment(this.todaysDate).subtract(12,'month').startOf('month').format('YYYY-MM-DD');
var check13 = moment(month13, 'YYYY/MM/DD');
this.month34 = check13.format('M');
this.year34  = check13.format('YYYY');
this.formattedMonth13 = moment(this.month34, 'MM').format('MMMM');

let argsmonth34 = {
 "developerId" : element.developerId,
 "applicationId" : element.applicationId,
 "month" : this.formattedMonth13,
 "year" : this.year34
}

this.isHidden13 = true;
this.applicationService.getMonthlyActiveUsers(argsmonth34).subscribe((data) => {
 if(data){
   element.count13 = data.info.count;
  if(data.info.count){
    this.isHidden13 = false;
  }
}
else{

}
}
,err =>{

});


       });
      
       this.arr =  this.applicationList;
       this.paginationCount = this.arr.length;
       this.dataSource = new MatTableDataSource(this.arr.slice((this.page - 1) * 10, (this.page - 1) * 10 + 10));
       this.pageLoader=false;
     
      }
      else{
        this.dataSource = [];
      }
    
     });
    
    
  }
  public applyFilter(filterValue: string) {  
    
    this.search = filterValue;
    this.page=1;
    this.arr =  this.applicationList;
    if(filterValue == ""){
      
      this.dataSource = new MatTableDataSource(this.arr.slice((this.page - 1) * 10, (this.page - 1) * 10 + 10));
      } else{ 
        
          
      var data1: any[];
      data1 = this.arr.filter(function (ele, i, array) {
        let arrayElementcompany = ele.company.toLowerCase();
        let arrayElementapplicationName = ele.applicationName.toLowerCase();
        return arrayElementcompany.includes(filterValue.toLowerCase()) || arrayElementapplicationName.includes(filterValue.toLowerCase());
      });
        
      this.arr = data1;
      this.dataSource = new MatTableDataSource(this.arr.slice((this.page - 1) * 10, (this.page - 1) * 10 + 10));       
      this.paginationCount= this.arr.length;   
    }
    
  }
  pageChanged2(page){
   
     this.dataSource = new MatTableDataSource(this.arr.slice((this.page - 1) * 10, (this.page - 1) * 10 + 10));
      
    }
    
   
}
